module.exports = __webpack_public_path__ + "img/coloredDiamonds.a49f991.webp";